import { Outlet, useParams } from "react-router";

export function ShippingHandler(props){
    
    let param = useParams();
    return <Outlet {...props} params={param} />
}